import reduce from 'ramda/es/reduce'
import max from 'ramda/es/max'
import pluck from 'ramda/es/pluck'

export const getMaxValueForEntries = (entries: any[][], index: number):any => reduce(max, 0, pluck(index, entries))
